module.exports = __webpack_public_path__ + "img/tennisdoubles.1006077e.svg";